import {Injectable} from "@angular/core";
import {FuseMockApiService, FuseMockApiUtils} from "../../../core/mock-api";
import {fidelityData} from "./data";
import {MenuData} from "../../../features/main-screen/main.types";
import {ApiResult} from "../../../shared/types/api-result.types";
import {SS_FIDELITY_EVALUATION_ENDPOINT} from "../../../features/stockstore-pos/stockstore-pos.types";
import {FidelityData} from "../../../features/fidelity/fidelity.types";


@Injectable({
  providedIn: 'root'
})
export class FidelityMockApi {
  private _fidelityData: FidelityData = fidelityData;

  /**
   * Constructor
   */
  constructor(private _fuseMockApiService: FuseMockApiService) {
    // Register Mock API handlers
    this.registerHandlers();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // -----------------------------------------------------------------------------------------------------
    // @ Tiles - GET
    // -----------------------------------------------------------------------------------------------------
    this._fuseMockApiService
      .onPost("http://127.0.0.1:1221/" + SS_FIDELITY_EVALUATION_ENDPOINT, 2000)
      .reply(() => {

        const data = FuseMockApiUtils.cloneDeep(this._fidelityData);

        const result: ApiResult<MenuData> = {
          result: data,
          isSuccess: true,
          errorMessages: [],
          statusCode: 200
        };

        return [200, result];
      });

  }
}
